import React, { Fragment, useState } from 'react'
import { Table } from 'react-bootstrap'
import product1 from '../../Assets/Images/product1.png'
import useMyAddress from '../../Hooks/MyProfile/useMyAddress'
import moment from 'moment'


const MyOrderTab = () => {

    const [viewDetail, setViewDetail] = useState(false)

    const [orderDetail, setOrderDetail] = useState([])
    const [orderNumber, setOrderNumber] = useState("")
    const [orderStatus, setOrderStatus] = useState(null)

    const handleOrderDetail = (item) => {
        setViewDetail(true)
        setOrderNumber(item?.order_number)
        setOrderDetail(item)
        setOrderStatus(item?.status)
    }

    const {
        selectedAddress,
        setSelectedAddress,
        isAddnewAddress,
        isLoading,
        allAddress,
        hanldeAddressLine1,
        hanldeAddressLine2,
        hanldeCity,
        hanldeState,
        hanldeCountry,
        hanldeZip,
        handleSubmit,
        handleDeleteAddress,
        setIsAddnewAddress,
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        zip,
        allOrders
    } = useMyAddress();

    console.log("allorders", allOrders)

    return (


        < Fragment >

            <div className="">

                <h5 className='fw-600 border-bottom pb-3'>My Orders</h5>


                {
                    viewDetail ? (
                        <>
                            <h5 className='s-18 pb-3'>Order ID {orderNumber}</h5>
                            {Array.isArray(orderDetail?.order_details) && orderDetail?.order_details?.length > 0 ? (
                                orderDetail?.order_details?.map((item, i) => {
                                    return (
                                        <>
                                            <div className="card bg-light border-0 mb-2">
                                                <div className="row align-items-center p-2">

                                                    <div className="col-auto">
                                                        <img src={product1} width={"113px"} height={"106.8px"} className='rounded-2' alt="" />
                                                    </div>

                                                    <div className="col ps-0">
                                                        <div className="row " >
                                                            <div className="col">
                                                                <h5 className='s-17 mb-0'>
                                                                    RennWrite Tshirt
                                                                </h5>
                                                            </div>
                                                            <div className="col-auto">
                                                                <h5 className='s-17 fw-500 mb-0 text-danger'>
                                                                    ${item?.price}
                                                                </h5>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-4">
                                                                <p className='s-16 text-muted mb-0'>
                                                                    Qty: {item?.qty}
                                                                </p>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className='s-16 mb-0 text-muted d-flex align-items-center'>
                                                                    Varient: <div>{item?.variant}</div>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-4">
                                                                <p className='s-16 text-muted mb-0'>
                                                                    {moment(item?.created_at).format("MMM Do YY")}
                                                                </p>
                                                            </div>
                                                            <div className="col-4 d-none">
                                                                <p className='s-16 mb-0 text-muted d-flex align-items-center'>
                                                                    Size: Small
                                                                </p>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className='s-16 mb-0 text-muted d-flex align-items-center'>
                                                                    Status: {orderStatus == 0 ? " Pending" : orderStatus == 1 ? ' Process' : orderStatus == 2 ? ' Shipped' : orderStatus == 3 ? ' Completed' : " Cancel"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            ) : ""}


                        </>) : (
                        <>
                            <div className="order-tab-table">
                                <Table >
                                    <thead>
                                        <tr style={{ height: "10px !important" }}>
                                            <th>Order ID</th>
                                            <th>Date</th>
                                            <th>Qty</th>
                                            <th>Total</th>
                                            <th>Status</th>
                                            <th className=''></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(allOrders) && allOrders?.length > 0 ? (
                                            allOrders?.map((item, i) => {
                                                return (
                                                    <>
                                                        <tr key={i}>
                                                            <td className='order-tab s-16 '> Order Id: {item?.order_number}</td>
                                                            <td className='s-16 order-tab'>{moment(item?.created_at).format("MMM Do YY")}</td>
                                                            <td className='s-16 order-tab'>{item?.no_of_product}</td>
                                                            <td className='s-16 order-tab'>{item?.total_amount}</td>
                                                            <td className='s-16 order-tab'>{item?.status == 0 ? " Pending" : item?.status == 1 ? ' Process' : item?.status == 2 ? ' Shipped' : item?.status == 3 ? ' Completed' : " Cancel"}</td>
                                                            <td className='s-16 order-tab text-danger cursor-pointer' onClick={() => handleOrderDetail(item)}>View Detail</td>
                                                        </tr>
                                                        <div className='bg-white py-1' />
                                                    </>
                                                )
                                            })
                                        ) : ("")}

                                    </tbody>
                                </Table>
                            </div>
                        </>)
                }

            </div>


        </Fragment >
    )
}

export default MyOrderTab